import { authCallbacks } from '@/helpers/authCallbacks'

window.authCallbacks = authCallbacks
